import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/liquidaciones';
import ReporteLiquidacionesProveedores from './ReporteLiquidacionesProveedores';


const ms2p = (state) => {
  return {
    ...state.liquidaciones,
    proveedor: state.login.proveedor,
    me: state.login.me,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(ReporteLiquidacionesProveedores);
